import script from "./BaseDialogBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDialogBox.vue?vue&type=script&setup=true&lang=js"

import "./BaseDialogBox.vue?vue&type=style&index=0&id=2fbee79a&lang=scss&scoped=true"

import exportComponent from "C:\\Humanfrog\\projects\\btc-lcz\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbee79a"]])

export default __exports__